import { render, staticRenderFns } from "./billet-doux-greeting-card.vue?vue&type=template&id=9aa04796&scoped=true"
import script from "./billet-doux-greeting-card.vue?vue&type=script&lang=js"
export * from "./billet-doux-greeting-card.vue?vue&type=script&lang=js"
import style0 from "./billet-doux-greeting-card.vue?vue&type=style&index=0&id=9aa04796&prod&lang=scss&scoped=true"
import style1 from "./billet-doux-greeting-card.vue?vue&type=style&index=1&id=9aa04796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa04796",
  null
  
)

export default component.exports